var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2671,
    viewBox: "0 0 1440 2671",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.132,
    y: 852.32,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 167.132 852.32)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.52,
    y: 628,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 138.52 628)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 529.935,
    y: 751.035,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 529.935 751.035)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.132,
    y: 2088.32,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 167.132 2088.32)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.52,
    y: 1864,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 138.52 1864)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 529.935,
    y: 1987.04,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 529.935 1987.04)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1447.13,
    y: 1627.32,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 1447.13 1627.32)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1418.52,
    y: 1403,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 1418.52 1403)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1809.94,
    y: 1526.04,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 1809.94 1526.04)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1562.13,
    y: 224.32,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 1562.13 224.32)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1533.52,
    width: 143.061,
    height: 680.972,
    rx: 71.5306,
    transform: "rotate(45 1533.52 0)",
    fill: "#6DB8FF",
    fillOpacity: 0.04
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundImage);
export default __webpack_public_path__ + "static/media/background-image.1e6db52a.svg";
export { ForwardRef as ReactComponent };